export const buildEntityGroupInputFields = (entityGroup) => [
  {
    name: 'name',
    label: 'Group Name',
    type: 'Input',
    value: entityGroup.name,
    required: true,
  },
];
